import {Component, Input, OnInit} from '@angular/core';
import {UploadService} from '@/_services/UploadService';
import {GlobalAbundanceServiceAD} from '@/_services/globalAbundanceAD.service';
import {AbstractFormDataUploadComponent} from '@/_components/common/upload/AbstractFormDataUploadComponent';

@Component({
    selector: 'app-global-abundance-update-ad',
    templateUrl: '../common/upload/upload.component.html',
    styleUrls: ['../common/upload/upload.component.css'],
    providers: [{provide: UploadService, useClass: GlobalAbundanceServiceAD}]
})
export class GlobalAbundanceUpdateADComponent extends AbstractFormDataUploadComponent implements OnInit {
    @Input() title;
    @Input() key = 'AD';
    @Input() AllowedFileTypes = '.xls,.xlsx';

    constructor(protected service: UploadService) {
        super(service);
    }

    ngOnInit() {
      this.fileKey = this.key;
      this.Intro = '<h3>' + this.title + '</h3>';
    }

}
